import { ComponentProps } from "react";
import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

import { formatLocale, isNumberText } from "../../utilities/format";

export const Group = BaseNumberField.Group;
export const Increment = BaseNumberField.Increment;
export const Decrement = BaseNumberField.Decrement;
export const ScrubArea = BaseNumberField.ScrubArea;
export const ScrubAreaCursor = BaseNumberField.ScrubAreaCursor;

export const Root = ({ format, ...props }: ComponentProps<typeof BaseNumberField.Root>) => (
  <BaseNumberField.Root locale={formatLocale()} {...props} format={{ ...format, useGrouping: false }} />
);

const withText = (input: HTMLInputElement, inserted: string) =>
  input.value.slice(0, input.selectionStart ?? input.value.length) + inserted + input.value.slice(input.selectionEnd ?? input.value.length);

export const Input = ({ onChange, onPaste, ...props }: ComponentProps<typeof BaseNumberField.Input>) => (
  <BaseNumberField.Input
    {...props}
    onChange={event => {
      if (isNumberText(event.currentTarget.value)) onChange?.(event);
      else event.preventBaseUIHandler();
    }}
    onPaste={event => {
      if (isNumberText(withText(event.currentTarget, event.clipboardData.getData("text/plain")))) {
        onPaste?.(event);
        return;
      }
      event.preventDefault();
      event.preventBaseUIHandler();
    }}
  />
);
